export const flyingEyeAttack = new Image();
flyingEyeAttack.src = "assets/characterSprites/flyingEye/Attack.png";
flyingEyeAttack.width = 1200/8;
flyingEyeAttack.height = 150/1;
flyingEyeAttack.yOffset = 10;
flyingEyeAttack.xOffset = 150;
flyingEyeAttack.cycleLoop = [0,1,2,3,4,5,6,7];